<script>
import { MoreVerticalIcon } from 'vue-feather-icons'
export default {
  components: { MoreVerticalIcon }
}
</script>
<template lang="pug">
button.btn(
  v-if="!$isRemoteClient"
  type="button"
  v-ea-click="() => {$router.push('/support')}"
)
  more-vertical-icon(size="1.5x")
</template>
